// resources/js/Pages/HallOfFame/components/ScoreCell.jsx
import React from 'react';
import { getHighlightClass } from '../utils/percentiles';

export default function ScoreCell({ percentile, rawScore, isScriptLevel = false, className = '' }) {
    const highlightClass = getHighlightClass(percentile);
    const classes = [highlightClass, className];
    
    if (isScriptLevel) {
        classes.push('script_color');
    }
    
    return (
        <td 
            className={classes.filter(Boolean).join(' ')}
            title={percentile !== null ? `${percentile}% (${rawScore.toFixed(1)})` : 'N/A'}
            style={{ fontWeight: 'bold' }}
        >
            {percentile !== null ? `${percentile}%` : 'N/A'}
        </td>
    );
}
